import { Shield, Award, CheckCircle, Heart, Clock, Truck } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";

interface TrustIndicatorProps {
  variant?: 'compact' | 'full' | 'badges';
  className?: string;
}

export const TrustIndicators = ({ variant = 'full', className = '' }: TrustIndicatorProps) => {
  const indicators = [
    {
      icon: Award,
      title: "30+ ans d'expérience",
      description: "Plus de 3 décennies dans l'événementiel",
      badge: "Expert",
      color: "text-accent"
    },
    {
      icon: Shield,
      title: "Sécurité garantie",
      description: "Équipements conformes aux normes CE",
      badge: "Sécurisé",
      color: "text-primary"
    },
    {
      icon: CheckCircle,
      title: "Assurance incluse",
      description: "Responsabilité civile professionnelle",
      badge: "Assuré",
      color: "text-secondary"
    },
    {
      icon: Heart,
      title: "Satisfaction client",
      description: "Plus de 5000 fêtes réussies",
      badge: "5000+ fêtes",
      color: "text-fun"
    },
    {
      icon: Clock,
      title: "Service rapide",
      description: "Réponse sous 24h garantie",
      badge: "Réactif",
      color: "text-warning"
    },
    {
      icon: Truck,
      title: "Livraison facile",
      description: "Transport dans une voiture normale",
      badge: "Pratique",
      color: "text-info"
    }
  ];

  if (variant === 'badges') {
    return (
      <div className={`flex flex-wrap gap-2 ${className}`}>
        {indicators.map((indicator, index) => (
          <Badge key={index} variant="secondary" className="bg-white/10 text-white border-white/20">
            <indicator.icon className="w-3 h-3 mr-1" />
            {indicator.badge}
          </Badge>
        ))}
      </div>
    );
  }

  if (variant === 'compact') {
    return (
      <div className={`grid grid-cols-2 md:grid-cols-3 gap-3 ${className}`}>
        {indicators.map((indicator, index) => (
          <div key={index} className="flex items-center space-x-2 bg-white/5 rounded-lg p-3">
            <indicator.icon className={`w-5 h-5 ${indicator.color}`} />
            <div>
              <div className="text-sm font-semibold text-white">{indicator.title}</div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 ${className}`}>
      {indicators.map((indicator, index) => (
        <Card key={index} className="shadow-gentle border-0 bg-white/95">
          <CardContent className="p-6 text-center">
            <div className={`w-12 h-12 mx-auto mb-4 rounded-full bg-gradient-subtle flex items-center justify-center`}>
              <indicator.icon className={`w-6 h-6 ${indicator.color}`} />
            </div>
            <h3 className="font-semibold text-foreground mb-2">{indicator.title}</h3>
            <p className="text-sm text-muted-foreground">{indicator.description}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};